




















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Route } from "vue-router";
import { IBlock, IDelegate, ISortParameters, ITransaction, IWallet } from "@/interfaces";
import TransactionService from "@/services/transaction";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  computed: {
    ...mapGetters("network", { networkSymbol: "symbol" }),
    ...mapGetters("network", ["hasHtlcEnabled"]),

    availableTransactionTypes() {
      const types = ["all", "sent", "received"];

      if (this.hasHtlcEnabled) {
        types.push("locks");
      }

      return types;
    },
  },
})
export default class WalletTransactions extends Vue {
  private transactions: ITransaction[] | null = null;
  private meta: any | null = null;
  private currentPage = 0;
  private selectOpen = false;
  private networkSymbol: string;

  get showPagination() {
    return this.meta && this.meta.pageCount > 1;
  }

  get address() {
    return this.$route.params.address;
  }

  get type() {
    return this.$store.getters["ui/walletTransactionTab"];
  }

  set type(type: string) {
    this.$store.dispatch("ui/setWalletTransactionTab", type);
  }

  get sortParams() {
    return this.$store.getters["ui/transactionSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setTransactionSortParams", {
      field: params.field,
      type: params.type,
    });
  }

  get isLocks() {
    return this.$route.params.type === "locks";
  }

  @Watch("currentPage")
  public onCurrentPageChanged() {
    this.changePage();
  }

  public async beforeRouteEnter(to: Route, from: Route, next: (vm: any) => void) {
    try {
      // @ts-ignore
      const { meta, data } = await TransactionService[`${to.params.type}ByAddress`](
        to.params.address,
        Number(to.params.page),
      );

      next((vm: WalletTransactions) => {
        vm.type = to.params.type;
        vm.currentPage = Number(to.params.page);
        vm.setTransactions(data);
        vm.setMeta(meta);
      });
    } catch (e) {
      next({ name: "404" });
    }
  }

  public async beforeRouteUpdate(to: Route, from: Route, next: (vm?: any) => void) {
    this.selectOpen = false;
    this.transactions = null;
    this.meta = null;

    try {
      // @ts-ignore
      const { meta, data } = await TransactionService[`${to.params.type}ByAddress`](
        to.params.address,
        Number(to.params.page),
      );

      this.type = to.params.type;
      this.currentPage = Number(to.params.page);
      this.setTransactions(data);
      this.setMeta(meta);
      next();
    } catch (e) {
      next({ name: "404" });
    }
  }

  private setTransactions(transactions: ITransaction[]) {
    if (!transactions) {
      return;
    }

    this.transactions = transactions.map((transaction) => ({
      ...transaction,
      price: null,
    }));
  }

  private setMeta(meta: any) {
    this.meta = meta;
  }

  private onPageChange(page: number) {
    this.currentPage = page;
  }

  private closeDropdown() {
    this.selectOpen = false;
  }

  private changePage() {
    if (this.currentPage !== Number(this.$route.params.page) || this.address !== this.$route.params.address) {
      // @ts-ignore
      this.$router.push({
        name: "wallet-transactions",
        params: {
          address: this.address,
          type: this.type,
          page: this.currentPage.toString(),
        },
      });
    }
  }

  // TODO: handle difference in locks vs all / received / sent pages
  private onSortChange(params: ISortParameters) {
    this.sortParams = params;
  }
}
